module.exports = __webpack_public_path__ + "eating.bae6161c.gif";


//////////////////
// WEBPACK FOOTER
// ./client/components/eating.gif
// module id = 482
// module chunks = 0